import { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import { getAISummary } from 'services/assistantSummaries'
import { useNotification } from 'components/Notification'
import { DEFAULT_AI_MODEL } from 'pages/IrwinAssistant/Summaries/utils'

const useAISummaries = willUseDefaultFormatting => {
  const { createNotification } = useNotification()

  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [selectedSecurity, setSelectedSecurity] = useState(null)
  const [selectedEntityId, setSelectedEntityId] = useState(null)
  const [selectedEntityType, setSelectedEntityType] = useState(null)
  const [promptPrefix, setPromptPrefix] = useState(null)
  const [promptSuffix, setPromptSuffix] = useState(null)
  const [selectedDataSource, setSelectedDataSource] = useState('activity')
  const [selectedModel, setSelectedModel] = useState(DEFAULT_AI_MODEL)

  const [isValidToSummarize, setIsValidToSummarize] = useState(false)
  useEffect(() => {
    setIsValidToSummarize(
      Boolean(selectedCustomer && selectedSecurity && selectedEntityId && selectedEntityType),
    )
  }, [selectedCustomer, selectedSecurity, selectedEntityId, selectedEntityType])

  const { data: assistantSummaryData, isLoading: assistantSummaryDataIsLoading } = useQuery(
    [
      'assistantSummary',
      {
        promptPrefix,
        promptSuffix,
        defaultInstructions: willUseDefaultFormatting,
        entityId: selectedEntityId,
        entityType: selectedEntityType,
        customerId: selectedCustomer?.id,
        securityId: selectedSecurity?.id,
        dataSource: selectedDataSource,
        aiModelName: selectedModel,
      },
    ],
    getAISummary,
    {
      onSuccess: data => {
        if (data?.status) {
          createNotification({
            message: 'Failed to generate a summary: ' + data.status,
            variant: 'error',
          })
        }
      },
      onError: error =>
        createNotification({
          message: error.response?.data?.error || error.message,
          variant: 'error',
        }),
      enabled: Boolean(
        (promptPrefix !== null || promptSuffix !== null) &&
          selectedEntityId &&
          selectedEntityType &&
          selectedCustomer &&
          selectedSecurity?.id &&
          selectedModel,
      ),
      refetchOnWindowFocus: false,
      useErrorBoundary: false,
      cacheTime: 0,
    },
  )

  return {
    selectedCustomer,
    setSelectedCustomer,
    selectedSecurity,
    setSelectedSecurity,
    selectedEntityId,
    setSelectedEntityId,
    selectedEntityType,
    setSelectedEntityType,
    promptPrefix,
    setPromptPrefix,
    promptSuffix,
    setPromptSuffix,
    selectedDataSource,
    setSelectedDataSource,
    selectedModel,
    setSelectedModel,
    assistantSummaryData,
    assistantSummaryDataIsLoading,
    isValidToSummarize,
  }
}

export default useAISummaries
